import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import ProgressCircle from "./ProgressCircle";
import Preloader from "./PreLoader";
import Footer from "./Footer";
import ChatbotWidget from './ChatbotWidget';
import "../styles/revamp.css";
// import Switcher from "./Switcher";

const Layout: React.FC = () => {
  return (
    <div>
      <Preloader />
      <div className="cursor1"></div>
      <div className="cursor2"></div>
      <ProgressCircle />
      {/* <Switcher /> */}
      <Header />
      <div className="has-smooth" id="has_smooth" />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <div className="body-wrapper">
            <Outlet />
            <Footer />
          </div>
        </div>
      </div>
      <ChatbotWidget apiKey={process.env.REACT_APP_CHATBOT_API_KEY || ""} />
    </div>
  );
};

export default Layout;
